import type { ReactNode } from 'react';
import { useState } from 'react';
import type { ContactInfo, NavigationItem } from '@/data/types';
import { Header } from './Header';
import { Navigation } from './Navigation';

interface LayoutProps {
  children: ReactNode;
  contactInfo: ContactInfo;
  navigationItems: NavigationItem[];
}

export function Layout({ children, contactInfo, navigationItems }: LayoutProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-neutral-50 font-sans">
      {/* Mobile Header */}
      <div className="lg:hidden bg-gradient-to-b from-neutral-800 to-neutral-900">
        <Header
          contactInfo={contactInfo}
          onMobileMenuToggle={toggleMobileMenu}
          isMobile={true}
        />
      </div>

      <div className="flex min-h-screen">
        {/* Desktop Sidebar - Fixed Position */}
        <div className="hidden lg:flex lg:w-88 bg-gradient-to-b from-neutral-800 to-neutral-900 flex-col shadow-medium fixed left-0 top-0 h-full z-30">
          <Header contactInfo={contactInfo} isMobile={false} />
          <Navigation items={navigationItems} />
        </div>

        {/* Mobile Navigation Overlay */}
        {isMobileMenuOpen && (
          <>
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
              onClick={closeMobileMenu}
            />
            <div className="fixed top-0 left-0 h-full w-88 bg-gradient-to-b from-neutral-800 to-neutral-900 z-50 transform transition-transform duration-300 ease-in-out lg:hidden shadow-medium">
              <Header contactInfo={contactInfo} isMobile={false} />
              <Navigation items={navigationItems} onItemClick={closeMobileMenu} />
            </div>
          </>
        )}

        {/* Main content */}
        <main className="flex-1 bg-white shadow-soft lg:ml-88">
          <div className="w-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}